import { render, staticRenderFns } from "./DashboardGeneral.vue?vue&type=template&id=0153b3d1&"
import script from "./DashboardGeneral.vue?vue&type=script&lang=js&"
export * from "./DashboardGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports